import { apiRequest } from '../client'
import type { ProductAssignment } from '../types'

export const assignmentsApi = {
  list: (sku: string) =>
    apiRequest<{ items: Array<ProductAssignment> }>(
      `/api/v0/admin/products/${encodeURIComponent(sku)}/assignments`,
    ),

  assign: (sku: string, restaurantId: number) =>
    apiRequest<{ ok: boolean }>(
      `/api/v0/admin/products/${encodeURIComponent(sku)}/assignments/${restaurantId}`,
      {
        method: 'PUT',
      },
    ),

  unassign: (sku: string, restaurantId: number) =>
    apiRequest<{ ok: boolean }>(
      `/api/v0/admin/products/${encodeURIComponent(sku)}/assignments/${restaurantId}`,
      {
        method: 'DELETE',
      },
    ),

  // Client-side bulk assign with Promise.allSettled
  bulkAssign: async (sku: string, restaurantIds: Array<number>) => {
    const results = await Promise.allSettled(
      restaurantIds.map((restaurantId) =>
        apiRequest(
          `/api/v0/admin/products/${encodeURIComponent(sku)}/assignments/${restaurantId}`,
          {
            method: 'PUT',
          },
        ),
      ),
    )

    const succeeded = results.filter((r) => r.status === 'fulfilled').length
    const failed = results.filter((r) => r.status === 'rejected').length

    return { succeeded, failed }
  },
}
